let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dVnnv")).then(() => parcelRequire('3t9pO'));